const buildMustFilters = brandIds => {
  const mustFilters = [];
  if (brandIds && brandIds.length) {
    brandIds.forEach(brandId => {
      mustFilters.push({ match: { 'brandIds.keyword': brandId } });
    });
  }
  return mustFilters;
};
export default buildMustFilters;
